import { CreateTicketCodes, GameTypeEnum, StatusCode } from "../enums/index";
import { ICreateTicketResponse, ICreateTicket } from "../interfaces/index";
import { getBetObject } from ".";

import { ApiConsumer } from "../services/ApiConsumer";
import store from "../store/store";
import AleaControlShell from "../communication/AleaControlShell";

export const createTicket = async (): Promise<ICreateTicket> => {
  const { currentStakeAmount } = store.getState().picks;
  const { balance, maxLocationStake, gameType } = store.getState().config;
  let successCode = CreateTicketCodes.ERROR;
  let newBalance;

  if (gameType === GameTypeEnum.ONLINE) {
    newBalance = balance;
  }

  let response: ICreateTicketResponse | null = null;
  if (
    (gameType === GameTypeEnum.ONLINE && currentStakeAmount * 100 > balance) ||
    (gameType === GameTypeEnum.PANEL &&
      currentStakeAmount * 100 > AleaControlShell.getBalance())
  ) {
    successCode = CreateTicketCodes.OUT_OF_MONEY;
  } else if (currentStakeAmount * 100 > maxLocationStake) {
    successCode = CreateTicketCodes.MAX_STAKE_REACHED;
  } else {
    try {
      response = await ApiConsumer.createTicket(
        store.getState().picks.pickedStakes.map((pick) => getBetObject(pick))
      );
      if (response.statusCode === StatusCode.OK) {
        if (gameType === GameTypeEnum.ONLINE) {
          newBalance = balance - currentStakeAmount * 100;
        }
        successCode = CreateTicketCodes.SUCCESS;
      } else if (response.statusCode === StatusCode.OUT_OF_MONEY) {
        successCode = CreateTicketCodes.OUT_OF_MONEY;
      } else {
        successCode = CreateTicketCodes.ERROR;
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
      if (e === StatusCode.BETTING_DISABLED) {
        successCode = CreateTicketCodes.BETTING_DISABLED;
      } else {
        successCode = CreateTicketCodes.ERROR;
      }
    }
  }
  return {
    successCode,
    balance: newBalance,
    payOutSum: response?.payOutSum,
    drawnNumber: response?.drawnNumber,
    multiplier: response?.multiplier,
    ticketItem: response?.ticketItems[0],
  };
};
